/**
 * Exact tab titles for public LATAM Cargo pages. No leading/trailing whitespace.
 * Desktop and mobile browsers use the same Document title / head title element for the tab label.
 */
export const LATAM_CARGO_PUBLIC_PAGE_TITLES = {
  unsubscribe: 'Unsubscribe | LATAM Cargo',
  unsubscribed: 'Unsubscribed | LATAM Cargo',
  feedbackSubmitted: 'Feedback Submitted | LATAM Cargo',
} as const;

function assertNoTitlePadding(text: string): void {
  if (text.length !== text.trim().length) {
    throw new Error('Document title must not have leading or trailing whitespace.');
  }
}

/**
 * Sets the text content of the title element in document.head.
 * Returns a function that restores the previous title text.
 */
export function applyDocumentHeadTitle(nextTitle: string): () => void {
  assertNoTitlePadding(nextTitle);

  let titleEl = document.head.querySelector('title');
  if (!titleEl) {
    titleEl = document.createElement('title');
    document.head.appendChild(titleEl);
  }

  const previous = titleEl.textContent ?? '';
  titleEl.textContent = nextTitle;

  return () => {
    const currentTitleEl = document.head.querySelector('title');
    if (currentTitleEl) {
      currentTitleEl.textContent = previous;
    } else {
      document.title = previous;
    }
  };
}
